export const LIST = "LIST";
export const LIST_CATEGORIES = "LIST_CATEGORIES";
export const ACTIVED = "ACTIVED";
export const IS_LOAD = "IS_LOAD";
export const ACTIVE_NEW = "ACTIVE_NEW";
export const TOGGLE_TAX_FORM = "TOGGLE_TAX_FORM";
export const PROVIDERS = "PROVIDERS";
export const PRODUCTS = "PRODUCTS";
export const SHOW_AMOUNT = "SHOW_AMOUNT";
export const SHOW_NUMBER = "SHOW_NUMBER";
export const SHOW_SUBMIT = "SHOW_SUBMIT";
export const ACCOUNT = "ACCOUNT";
export const SHOW_ERROR = "SHOW_ERROR";
export const ERRORS = "ERRORS";
export const SHOW_SUCCESS = "SHOW_SUCCESS";
export const SHOW_CONFIRM = "SHOW_CONFIRM";
export const SHOW_CANCEL = "SHOW_CANCEL";
export const SHOW_FILTERS = "SHOW_FILTERS";
export const SET_PARTNER_DATA = "SET_PARTNER_DATA";
export const SET_CATEGORIES_DATA = "SET_CATEGORIES_DATA";
export const SET_CEP_DATA = "SET_CEP_DATA";
export const LIMIT = "LIMIT";
export const PAGE = "PAGE";
export const LIMIT_OPTIONS = "LIMIT_OPTIONS";
export const SET_TOTAL_RESOURCES = "SET_TOTAL_RESOURCES";

export const SET_FILTER_INITIAL_DATE = "SET_FILTER_INITIAL_DATE";
export const SET_FILTER_FINAL_DATE = "SET_FILTER_FINAL_DATE";
export const SET_FILTER_PARTNER_INITIAL_DATE = "SET_FILTER_PARTNER_INITIAL_DATE";
export const SET_FILTER_PARTNER_FINAL_DATE = "SET_FILTER_PARTNER_FINAL_DATE";
export const SET_FILTER_ORDINATION = "SET_FILTER_ORDINATION";
export const SET_FILTER_STATUS = "SET_FILTER_STATUS";
export const SET_FILTER_NAME = "SET_FILTER_NAME";
export const SET_FILTER_ACCOUNT_TYPE = "SET_FILTER_ACCOUNT_TYPE";
export const SET_FILTER_PARTNER = "SET_FILTER_PARTNER";
export const FILTER_PARTNER = "FILTER_PARTNER";
export const LOADING_DATA = "LOADING_DATA";

export const FILTER_PARAMS = "FILTER_PARAMS";
export const FILTER_STATUS = "FILTER_STATUS";
export const SET_SUMMARY = "SET_SUMMARY";
